
import { Mixins, Component, Watch } from 'vue-property-decorator';
import {
  Card,
  Col,
  Button,
  Row,
  Form,
  FormItem,
  Input,
  Upload,
  Pagination,
} from 'element-ui';
import { tSearch } from '@/components/Search/index';
import api from '@/api/sensitive';
import bModal from './components/bModal.vue';
import tData from './components/data.vue';
import pageMixin from '../../../mixins/pageMixin';


@Component({
  components: {
    Card,
    Col,
    Button,
    Row,
    Input,
    Form,
    FormItem,
    bModal,
    tSearch,
    Upload,
    tData,
    Pagination,
  },
})

export default class cardList extends Mixins(pageMixin) {
  private dialogVisible: boolean = false;

  private loading: boolean = false;

  private searchString: any = '';

  private sensitiveList: any = {};

  mounted() {
    this.page.pageSize = 50;
    this.pageSizes = [50, 100, 150];
  }

  addClick() {
    this.dialogVisible = true;
  }

  /**
   * @author niuhong
   * @desc 文件上传前事件
   */
  // handleBeforeUpload(file: File) {
  //   const data: any = new FormData();
  //   data.append('file', file);
  //   api.addTxt(data).then((res: any) => {
  //     this.getData();
  //   });
  //   return false;
  // }

  /**
   * @author niuhong
   * @desc 敏感词删除后事件
   */
  delFinish() {
    this.getData();
  }

  /**
   * @author niuhong
   * @desc 敏感词添加后事件
   */
  addFinish() {
    this.getData();
  }

  /**
   * @author niuhong
   * @desc 搜索change事件
   */
  handleSearchChange(val: string) {
    this.getData({ word: val }, true);
    this.searchString = val;
  }

  enterSearch() {
    this.getData({ word: this.searchString }, true);
  }

  getData(params?: any, refresh: boolean = false) {
    if (refresh) {
      this.page.pageNo = 1;
    }
    this.loading = true;
    this.page.params = params;
    const data = { pageSize: this.page.pageSize, pageNo: this.page.pageNo, ...this.page.params };
    api.getSensitive(data).then((res: any) => {
      this.sensitiveList = res.content;
      this.total = res.totalElements;
      this.loading = false;
    });
  }

  @Watch('page', { immediate: false, deep: true })
  handlePageChange() {
    this.getData({ word: this.searchString });
  }
}
